import config from "../../config/environment.js";

// Export entity configuration for use in routes
export const emvEntity = {
  title: "EMV",
  friendlyPath: "emv",
  path: config.entities.emv,
  columns: [
    { dataField: "line", text: "Línea", isForTable: true, sort: true },
    { dataField: "branch", text: "Ramal", isForTable: true, sort: true },
    {
      dataField: "description",
      text: "Descripción",
      isForTable: true,
      sort: true,
    },
    { dataField: "value", text: "Tarifa", isForTable: true, sort: true },
    { dataField: "date", text: "Fecha", isForTable: true, sort: true },
  ],
};
